<template>
  <el-date-picker
    class="btn-date-picker"
    type="daterange"
    align="center"
    :placeholder="placeholder"
    :editable="editable"
    :clearable="clearable"
    :range-separator="rangeSeparator"
    :picker-options="usePickerOptions"
    :format="format"
    :value-format="valueFormat"
    :value="dateValue"
    @input="onInput"
    @clear="$emit('clear', $event)"
  ></el-date-picker>
</template>

<script>
const shortcuts = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date()
      picker.$emit('pick', [start, end])
    },
  },
  {
    text: '昨天',
    onClick(picker) {
      // const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
      picker.$emit('pick', [start, start])
    },
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    },
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    },
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    },
  },
]
export default {
  name: 'kx-date-picker', // 时间范围
  props: {
    timeStart: {
      type: [String],
      default: ''
    },
    timeEnd: {
      type: [String],
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '选择日期范围',
    },
    rangeSeparator: {
      type: String,
      default: '-',
    },
    format: {
      type: [String],
      default: 'yyyy-MM-dd'
    },
    valueFormat: {
      type: [String],
      default: 'yyyy-MM-dd'
    },
    no3Month: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  model: {
    prop: 'timeStart',
    event: 'input',
  },
  computed: {
    dateValue() {
      const { timeStart, timeEnd } = this
      return [timeStart || '', timeEnd || '']
    },
    usePickerOptions() {
      const { no3Month } = this
      let useShortcuts = shortcuts
      if (no3Month) {
        useShortcuts = useShortcuts.filter((el) => {
          return el.text !== '最近三个月'
        })
      }
      return { shortcuts: useShortcuts }
    },
  },
  created() {},
  methods: {
    onInput($event) {
      const dateArr = $event ? $event : []
      this.$emit('input', dateArr[0] || '')
      this.$emit('update:timeEnd', dateArr[1] || '')
    },
  },
}
</script>
